module.exports = __webpack_public_path__ + "img/UTGOBL-2.71499a7a.jpg";